export const QueryKey = {
  BALANCES: ['billing', 'balances'],
  PAST_DUE_LOCATIONS: ['billing', 'past-due-locations'],
} as const
